/* tslint:disable */

declare var Object: any;
export interface MigrationInterface {
  "id"?: number;
}

export class Migration implements MigrationInterface {
  "id": number;
  constructor(data?: MigrationInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Migration`.
   */
  public static getModelName() {
    return "Migration";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Migration for dynamic purposes.
  **/
  public static factory(data: MigrationInterface): Migration{
    return new Migration(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Migration',
      plural: 'migrations',
      path: 'migrations',
      idName: 'id',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/sdk/models/Migration.ts